import en from './langs/en'
import pt from './langs/pt'

export default {
    en,
    pt
}